<template>
  <div class="the-administrator-view" style="padding: 2ex;">
    <div id="searchBox">
      <input
        type="text"
        placeholder="Email of user"
        name="searchEmail"
        id="searchEmail"
        v-model="searchEmail"
      />
    </div>
    <table class="list">
      <tr>
        <th>ID</th>
        <th>Email</th>
        <th>fmId</th>
        <th>cmsId</th>
      </tr>

      <tr
        @click="shadowUser(user)"
        class="clickable"
        v-for="user in userList"
        :key="user.id"
      >
        <td>{{ user.id }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.fmId }}</td>
        <td>{{ user.cmsId }}</td>
      </tr>
    </table>
  </div>
</template>

<script lang="ts">
export interface UserReference {
  email: string;
  id: number;
  fmId: number;
  cmsId: number;
}

import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class TheAdministratorView extends Vue {
  public userList: UserReference[] = [];
  public searchEmail = "";

  public intervalTimeOut: number | undefined;

  @Watch("searchEmail")
  public async onSearchEmail() {
    clearTimeout(this.intervalTimeOut);

    if (!this.searchEmail) return;

    this.intervalTimeOut = window.setTimeout(async () => {
      const response = await this.$axios
        .get<UserReference[]>(`/admin/users?searchEmail=${this.searchEmail}`)
        .catch(er => {
          this.$swal.fire(
            "Could not load user list",
            `${er.message}<br>${er.response.data.error}`
          );
        });

      if (response) this.userList = response.data;
    }, 500);
  }

  public async shadowUser(user: UserReference) {
    this.$axios
      .post<{ token: string }>("/admin/shadow", { userId: user.id })
      .then(response => {
        this.$store.state.isShadow = true;
        this.$store.commit("setToken", response.data.token);
        this.$axios.defaults.headers.common.Authorization =
          "Bearer " + localStorage.getItem("authenticationToken");
        this.$router.push("/rma/create");
      })
      .catch(() => {
        this.$swal.fire("Could not shadow user", "er.message");
      });
  }
}
</script>

<style scoped>
#searchBox {
  padding: 1ex;
  width: 100%;
}

#searchBox input {
  padding: 5px;
  border: 1px solid black;
  width: 97%;
  display: block;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  padding: 5px;
  font-size: 92%;
}

th {
  background-color: #001538;
  color: white;
  font-weight: normal;
  font-family: "Overpass", sans-serif !important;
  padding: 4px;
  padding-top: 6px;
  text-align: left;
  border-left: 1px solid gray;
  font-weight: 200;
}

td {
  border-left: 1px dotted gray;
  border-bottom: 1px dotted gray;
}

.clickable {
  cursor: pointer;
}

.clickable:hover {
  background-color: #ccc;
}
</style>
